var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconManufacturing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70,17.25H22.75V12a.7502.7502,0,0,0-.75-.75H16A6.75769,6.75769,0,0,0,9.25,18V62A6.75769,6.75769,0,0,0,16,68.75H70a.7502.7502,0,0,0,.75-.75V18A.7502.7502,0,0,0,70,17.25ZM10.75,18A5.25605,5.25605,0,0,1,16,12.75h5.25v42.5H16a6.73806,6.73806,0,0,0-5.25,2.5166Zm58.5,49.25H16a5.25,5.25,0,0,1,0-10.5h6a.7502.7502,0,0,0,.75-.75V18.75h46.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32,56.75H60a.7502.7502,0,0,0,.75-.75V28a.7502.7502,0,0,0-.75-.75H32a.7502.7502,0,0,0-.75.75V56A.7502.7502,0,0,0,32,56.75Zm12.417-28h3.166v12.5H44.417Zm-11.667,0H42.917V42a.7502.7502,0,0,0,.75.75h4.666a.7502.7502,0,0,0,.75-.75V28.75H59.25v26.5H32.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManufacturing);
export default __webpack_public_path__ + "static/media/icon_manufacturing.b36408bca0b5ae2c51c266d2e24b6a25.svg";
export { ForwardRef as ReactComponent };